<script>
  let eventMap = [];
  let thisMap = [];

  export default {
    methods: {
        subscriber (eventName, eventHandler, self) {
            this.eventMap[eventName] = eventHandler;
            this.thisMap[eventName] = self;
        },
        unsubscriber(eventName) {
            delete this.eventMap[eventName];
            delete this.thisMap[eventName];
        },
        publisher(eventName, parameters) {
            // {}はグローバルオブジェクト(windowでも可)
            // applyの第2引数は配列のみ (apply内で配列を引数リストへ分解してfunctionを呼び出している)
            return (this.eventMap[eventName]).apply(this.thisMap[eventName], parameters);
        }
    },
    data () {
      return {
        eventMap: eventMap,
        thisMap: thisMap
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/common/mediator.vue